import { PropsWithChildren } from 'react'
import { CorporateActiveBanner } from '../CorporateActiveBanner/CorporateActiveBanner'
import { useCorporateActiveBanner } from '../CorporateActiveBanner/useCorporateActiveBanner'
import { FeedbackAlert } from '../FeedbackAlert/FeedbackAlert'
import { Header } from '../Header/Header'
import { LayoutEmpty } from './LayoutEmpty'

interface Props {
  withUser?: boolean
}
const LayoutSimple = ({ children, withUser }: PropsWithChildren<Props>) => {
  const { activeBanner, isBannerToBeDisplayed } = useCorporateActiveBanner()

  return (
    <LayoutEmpty>
      {isBannerToBeDisplayed && activeBanner ? (
        <CorporateActiveBanner activeBanner={activeBanner} />
      ) : null}
      <Header withUser={withUser} />
      <div className="flex flex-row">
        <div className="relative flex min-h-dashboardViewport min-w-0 flex-1 justify-center">
          {children}
          <FeedbackAlert />
        </div>
      </div>
    </LayoutEmpty>
  )
}

export default LayoutSimple
